import type { RawAxiosHeaders } from "axios";
import axios, { Axios } from "axios";

import { isBrowser } from "@citrine/configuration";

import { refreshAccessToken } from "./refresh-client";

export const clientInstance = new Axios();
clientInstance.defaults = axios.defaults;
clientInstance.defaults.withCredentials = true;

export async function configureClient({
  apiKey,
  baseURL,
  headers,
}: {
  apiKey?: string;
  baseURL?: string;
  headers?: RawAxiosHeaders;
}) {
  // do not allow client configuration in browser
  if (isBrowser) {
    return;
  }

  if (baseURL) {
    clientInstance.defaults.baseURL = baseURL;
  }
  if (headers) {
    Object.entries(headers).forEach(([key, value]) => {
      clientInstance.defaults.headers.common[key] = value;
    });
  }

  clientInstance.interceptors.request.clear();
  if (apiKey) {
    clientInstance.interceptors.request.use((requestConfig) => {
      const cookieHeader = requestConfig.headers.get("Cookie");
      const existingCookie =
        typeof cookieHeader === "string" ? cookieHeader : "";
      if (!/(^|;) *refresh_token=/.test(existingCookie)) {
        requestConfig.headers.set(
          "Cookie",
          [existingCookie, `refresh_token=${apiKey}`]
            .filter(Boolean)
            .join("; "),
        );
      }
      return requestConfig;
    });

    await refreshAccessToken();
  }
}
